import React from 'react'
import { Block } from '../../Globals'
import sideBgImage from '@assets/images/Right_Faded_BW.jpg'
import { chunkArray, generateRandomKey } from '@utils'
import { useMediaQuery } from '@hooks'
import { sizes } from '@theme'
import { InfiniteList } from '../../List'
import GridRow from '../../Row/components/GridRow'
import Box from '@components/Box'

const News = ({ tabContent, imgUrl = true }) => {
  const rowHeights = {
    xs: 250,
    sm: 250,
    md: 300,
    lg: 300,
    xl: 300,
  }

  const xs = useMediaQuery(`(max-width: ${sizes.xsmall.max})`)
  const md = useMediaQuery(`(max-width: ${sizes.medium.max})`)

  const numColumns = (xs && 1) || (md && 2) || 3
  const borderTop =
    tabContent && tabContent.length > 3 ? '1px solid #DDE0E3' : 'none'
  return (
    <Block imgUrl={imgUrl && sideBgImage} padding="0">
      <Box
        py="50px"
        maxWidth={['90%', '540px', '720px', '960px', '1200px']}
        mx="auto"
      >
        <Box borderTop={borderTop}>
          <InfiniteList rowHeights={rowHeights} maxHeight={700}>
            {tabContent &&
              chunkArray(tabContent, numColumns).map(item => (
                <GridRow
                  key={generateRandomKey()}
                  numColumns={numColumns}
                  items={item}
                  numItems={tabContent.length}
                  rowHeights={rowHeights}
                  contentfulType={null}
                  borderLeft="1px solid #DDE0E3"
                />
              ))}
          </InfiniteList>
        </Box>
      </Box>
    </Block>
  )
}

export default News
